/**
 * Supported language locales
 * Defines available languages for user selection
 */

/** Language locale configuration */
export interface Language {
  value: string
  displayText: string
  default: boolean
}

export const languages: readonly Language[] = [
  { value: 'de-DE', displayText: 'Deutsch', default: true },
  { value: 'el-GR', displayText: 'Ελληνικά', default: true },
  { value: 'en-GB', displayText: 'English (United Kingdom)', default: false },
  { value: 'en-US', displayText: 'English (United States)', default: true },
  { value: 'es-ES', displayText: 'Español (España)', default: false },
  { value: 'es-MX', displayText: 'Español (México)', default: true },
  { value: 'fr-FR', displayText: 'Français', default: true },
  { value: 'it-IT', displayText: 'Italiano', default: true },
  { value: 'ja-JP', displayText: '日本語', default: true },
  { value: 'nl-NL', displayText: 'Nederlands', default: true },
  { value: 'pl-PL', displayText: 'Polski', default: true },
  { value: 'pt-BR', displayText: 'Português (Brasil)', default: false },
  { value: 'pt-PT', displayText: 'Português (Portugal)', default: true },
  { value: 'tr-TR', displayText: 'Türkçe', default: true },
] as const

/** Array of language codes */
export const languageCodes: readonly string[] = languages.map(item => item.value)

/** Union type of all language locale codes */
export type LanguageCode = typeof languages[number]['value']
// Type: 'de-DE' | 'el-GR' | 'en-GB' | 'en-US' | ... (14 values)

